<template>
  <div class="chartheight" ref="chart"></div>
</template>

<script>
const colorArr = [
  "#7f86ea",
  "#ff6b6b",
  "#F3F3F3",
  "#FFB95E",
  "#5882FB",
  "#49C568",
  "#AEB3F1",
  "#CCCCCC",
];
export default {
  props: {
    resData: null,
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      myCharts: null,
      chartData: [
        // { value: 120, name: "女", itemStyle: { color: "#FF872F" } },
        // { value: 350, name: "男", itemStyle: { color: "#11CE99" } },
        // { value: 660, name: "未识别", itemStyle: { color: "#5882FB" } },
      ],
    };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.chartData = this.resData.map((item, index) => {
        return {
          value: item.count,
          name: item.name,
          itemStyle: { color: colorArr[index] },
        };
      });
      this.initChart();
      window.addEventListener("resize", () => {
        this.myCharts.resize();
      });
    });
  },
  methods: {
    initChart() {
      this.myCharts = this.$echarts.init(this.$refs.chart);
      let arr = [];
      this.chartData.forEach((item, index) => {
         arr.push(item);
        // if (item.value != 0) {
        //    arr.push(item);
          // this.chartData.splice(index, 1);
        // }
      });
      this.setOptions(arr);
      // this.setOptions(this.sex);
    },
    setOptions(data) {

      let options = {
        // 提示框组件
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} 人 ({d}%)",
        },
        legend: {
          bottom: -5,
          icon: "circle",
          data: data.map((i) => i.name),
          itemWidth: 8,
          itemHeight: 8,
        },
        // 系列列表。每个系列通过 type 决定自己的图表类型
        series: {
          name: this.resData.labelMeaning,
          type: "pie",
          radius: ["50%", "65%"],
          avoidLabelOverlap: true,
          label: {
            show: this.showLabel,
            // formatter: "{b}: {@2012}\n({d}%)",
            formatter:function(params){
              let clientWidth = document.body.clientWidth
              // 根据当前网页的宽度来决定显示文字个数
              let overValue = ''
              if(clientWidth > 1920) {
                overValue += params.name
                overValue += ':'
                overValue += params.value
                overValue += '\n'
                overValue +=  `(${params.percent}%)`
              } else if(1600 < clientWidth && clientWidth < 1920) {
                if(params.name.length === 9) {
                  overValue += params.name.substring(0,7)
                  overValue += '\n'
                  overValue += params.name.substring(7,params.name.length)
                  overValue += ':'
                  overValue += params.value
                  overValue += '\n'
                  overValue +=  `(${params.percent}%)`
                } else {
                  overValue += params.name
                  overValue += ':'
                  overValue += params.value
                  overValue += '\n'
                  overValue +=  `(${params.percent}%)`
                }
              } else if(1420 < clientWidth && clientWidth < 1600) {
                if(params.name.length === 9) {
                  overValue += params.name.substring(0,3)
                  overValue += '\n'
                  overValue += params.name.substring(3,6)
                  overValue += '\n'
                  overValue += params.name.substring(6,params.name.length)
                  overValue += ':'
                  overValue += '\n'
                  overValue += params.value
                  overValue += '\n'
                  overValue +=  `(${params.percent}%)`
                } else {
                  overValue += params.name
                  overValue += ':'
                  overValue += params.value
                  overValue += '\n'
                  overValue +=  `(${params.percent}%)`
                }
              } else if(1220 < clientWidth && clientWidth < 1440) {
                if(params.name.length === 9) {
                  overValue += params.name.substring(0,3)
                  overValue += '\n'
                  overValue += params.name.substring(3,6)
                  overValue += '\n'
                  overValue += params.name.substring(6,params.name.length)
                  overValue += ':'
                  overValue += '\n'
                  overValue += params.value
                  overValue += '\n'
                  overValue +=  `(${params.percent}%)`
                } else {
                  overValue += params.name
                  overValue += ':'
                  overValue += params.value
                  overValue += '\n'
                  overValue +=  `(${params.percent}%)`
                }
              } else {
                if(params.name.length === 9) {
                  overValue += params.name.substring(0,3)
                  overValue += '\n'
                  overValue += params.name.substring(3,6)
                  overValue += '\n'
                  overValue += params.name.substring(6,params.name.length)
                  overValue += ':'
                  overValue += '\n'
                  overValue += params.value
                  overValue += '\n'
                  overValue +=  `(${params.percent}%)`
                } else {
                  overValue += params.name
                  overValue += ':'
                  overValue += params.value
                  overValue += '\n'
                  overValue +=  `(${params.percent}%)`
                }
              }
              return overValue
            },
            color: "#333",
            position: "outer",
            alignTo: "edge",
            margin: 10,
            // position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: "14",
              fontWeight: "bold",
            },
          },
          labelLine: {
            show: true,
          },
          data: data,
        },
        itemStyle: {
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      };
      this.myCharts.setOption(options);
    },
  },
};
</script>


<style scoped lang="scss">
.chartheight{
      height: 310px;
            @media screen and (max-width: 1400px){
              margin-top: 0px;
          height: 250px;
        }
          @media screen and (max-width: 1340px){
            margin-top: 0px;
          height: 180px;
        }
}
.order_money {
  height: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  overflow: hidden;
  .head {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 54px;
    padding: 0 24px;
    span {
      color: #2e3458;
      font-size: 16px;
      font-weight: 800;
    }
    img {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
    border-bottom: 1px solid #f6f6f6;
  }
  .content {
    height: 306px;
  }
}
</style>